import React from 'react';

export const LotteryBall = ({ 
  number, 
  variant = 'default', 
  size = 'md',
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-10 h-10 text-sm',
    md: 'w-14 h-14 text-lg',
    lg: 'w-20 h-20 text-2xl',
    xl: 'w-24 h-24 text-3xl'
  };

  const variantClasses = {
    default: 'lottery-ball',
    hot: 'lottery-ball-hot',
    cold: 'lottery-ball-cold',
    recommended: 'lottery-ball-recommended'
  };

  return (
    <div 
      className={`${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      data-testid={`lottery-ball-${number}`}
    >
      <span className="font-mono font-bold text-white">
        {String(number).padStart(2, '0')}
      </span>
    </div>
  );
};

export const LotteryBallGroup = ({ numbers, variant = 'default', size = 'md' }) => {
  return (
    <div className="flex gap-3 items-center justify-center flex-wrap" data-testid="lottery-ball-group">
      {numbers.map((num, idx) => (
        <LotteryBall 
          key={`ball-${num}-${idx}`} 
          number={num} 
          variant={variant} 
          size={size} 
        />
      ))}
    </div>
  );
};

export default LotteryBall;
